
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.17,"time":10200.000000000002,"words":34}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className="flavor-text">
      <p>{`Sara is a former West African princess rescued from slavery and befriended by the court of the Queen.`}</p>
    </div>
    <p><img parentName="p" {...{
        "src": "./sara-forbes-bonetta.jpg"
      }}></img></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Sara Forbes Bonetta",
  "vp": 4,
  "casual": true,
  "starter": false
}

